import { render, staticRenderFns } from "./MyGrey.vue?vue&type=template&id=74db47da&scoped=true&"
import script from "./MyGrey.vue?vue&type=script&lang=js&"
export * from "./MyGrey.vue?vue&type=script&lang=js&"
import style0 from "./MyGrey.vue?vue&type=style&index=0&id=74db47da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74db47da",
  null
  
)

export default component.exports